import { UseFieldArrayRemove } from 'react-hook-form'
import { useOutletContext } from 'react-router-dom'

export interface Context {
  removeOption: UseFieldArrayRemove
}

export function useContextRemoveOption() {
  const { removeOption } = useOutletContext<Context>()
  return removeOption
}
